export enum TagsValidation {
    NonAlphanumeric = "Tags must contain only numbers or letters",
    LimitReached = "Tag limit reached (8)",
    TooShort = "Minimum character count (3)",
    Exist = "This tag already exists",
    Valid = "",
}
